import React, { FC } from 'react';

import { SidePanelBodyProps } from './SidePanel.types';
import cx from 'classnames';
import './sidepanel.scss';

export const SidePanelBody: FC<SidePanelBodyProps> = ({
	className = "gtc-rc-side-panel-body",
	children,
	style = {},
}) => {
	return (
        <div 
            className={cx(className)} 
            style={style}
        >
            {children}
        </div>
    )
};